module.exports = __webpack_public_path__ + "img/labpic.ca5b9706.jpeg";